import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment,useRef} from 'react';
import {Typography,Button,Box,Grid, TextField,Paper, MenuItem} from "@mui/material";
import apiRequest from '../../../functions/api';
import { useMessage } from '../../../context/message-context';
import DynamicTable from "../components/DynamicTableComponent";
import Page from "../components/PageComponent";
import { FullPageSpinner } from "../../lib";
import MessageBox from "../components/MessageBox";
function TurnusAuswahl(props) {
  const { t } = useTranslation();
const { accessToken,  client, setOpen,programm,setTurnusKey,startTurnus,} = props;
const spalten=[
  {"bez":"Bezeichnung","breite":"3","key":"BEZ"},{"bez":"Auswahl","art":"checkbox","key":"AUSWAHL"}
]
const spaltenlock=[
  {"bez":"Bezeichnung","breite":"3","key":"BEZ"},{"bez":"Auswahl","art":"checkbox","key":"AUSWAHL","disabled":"J"}
]
const neu_arbeitstage=[
  {"AUSWAHL":"0","BEZ":"Montag","KEY":"ARBEITSTAGE_1"},{"AUSWAHL":"0","BEZ":"Dienstag","KEY":"ARBEITSTAGE_2"},{"AUSWAHL":"0","BEZ":"Mittwoch","KEY":"ARBEITSTAGE_3"},{"AUSWAHL":"0","BEZ":"Donnerstag","KEY":"ARBEITSTAGE_4"},
  {"AUSWAHL":"0","BEZ":"Freitag","KEY":"ARBEITSTAGE_5"},{"AUSWAHL":"0","BEZ":"Samstag","KEY":"ARBEITSTAGE_6"},{"AUSWAHL":"0","BEZ":"Sonntag","KEY":"ARBEITSTAGE_7"},
]
const neu_monate=[
    {"AUSWAHL":"0","BEZ":"Januar","KEY":"MONAT_1"},{"AUSWAHL":"0","BEZ":"Februar","KEY":"MONAT_2"},{"AUSWAHL":"0","BEZ":"März","KEY":"MONAT_3"},{"AUSWAHL":"0","BEZ":"April","KEY":"MONAT_4"},
    {"AUSWAHL":"0","BEZ":"Mai","KEY":"MONAT_5"},{"AUSWAHL":"0","BEZ":"Juni","KEY":"MONAT_6"},{"AUSWAHL":"0","BEZ":"Juli","KEY":"MONAT_7"},{"AUSWAHL":"0","BEZ":"August","KEY":"MONAT_8"},
    {"AUSWAHL":"0","BEZ":"September","KEY":"MONAT_9"},{"AUSWAHL":"0","BEZ":"Oktober","KEY":"MONAT_10"},{"AUSWAHL":"0","BEZ":"November","KEY":"MONAT_11"},{"AUSWAHL":"0","BEZ":"Dezember","KEY":"MONAT_12"},
]
const neu_tage=[
  {"AUSWAHL":"0","BEZ":"1","KEY":"TAG_1"},{"AUSWAHL":"0","BEZ":"2","KEY":"TAG_2"},{"AUSWAHL":"0","BEZ":"3","KEY":"TAG_3"},{"AUSWAHL":"0","BEZ":"4","KEY":"TAG_4"},{"AUSWAHL":"0","BEZ":"5","KEY":"TAG_5"},{"AUSWAHL":"0","BEZ":"6","KEY":"TAG_6"},{"AUSWAHL":"0","BEZ":"7","KEY":"TAG_7"},{"AUSWAHL":"0","BEZ":"8","KEY":"TAG_8"},{"AUSWAHL":"0","BEZ":"9","KEY":"TAG_9"},{"AUSWAHL":"0","BEZ":"10","KEY":"TAG_10"},
  {"AUSWAHL":"0","BEZ":"11","KEY":"TAG_11"},{"AUSWAHL":"0","BEZ":"12","KEY":"TAG_12"},{"AUSWAHL":"0","BEZ":"13","KEY":"TAG_13"},{"AUSWAHL":"0","BEZ":"14","KEY":"TAG_14"},{"AUSWAHL":"0","BEZ":"15","KEY":"TAG_15"},{"AUSWAHL":"0","BEZ":"16","KEY":"TAG_16"},{"AUSWAHL":"0","BEZ":"17","KEY":"TAG_17"},{"AUSWAHL":"0","BEZ":"18","KEY":"TAG_18"},{"AUSWAHL":"0","BEZ":"19","KEY":"TAG_19"},{"AUSWAHL":"0","BEZ":"20","KEY":"TAG_20"},
  {"AUSWAHL":"0","BEZ":"21","KEY":"TAG_21"},{"AUSWAHL":"0","BEZ":"22","KEY":"TAG_22"},{"AUSWAHL":"0","BEZ":"23","KEY":"TAG_23"},{"AUSWAHL":"0","BEZ":"24","KEY":"TAG_24"},{"AUSWAHL":"0","BEZ":"25","KEY":"TAG_25"},{"AUSWAHL":"0","BEZ":"26","KEY":"TAG_26"},{"AUSWAHL":"0","BEZ":"27","KEY":"TAG_27"},{"AUSWAHL":"0","BEZ":"28","KEY":"TAG_28"},{"AUSWAHL":"0","BEZ":"29","KEY":"TAG_29"},{"AUSWAHL":"0","BEZ":"30","KEY":"TAG_30"},
  {"AUSWAHL":"0","BEZ":"31","KEY":"TAG_31"},
]
const [arbeitstage,setArbeitestage]=useState([]);
const [tage,setTage]=useState([]);
const [monate,setMonate]=useState([]);
const [options,setOptions] = useState([]);
const fehlertext=useRef("");
const [feiertag,setFeiertag]=useState("0")
const [anlagename,setAnlageName] = useState("");
const [spin,setSpin]=useState(false)
const {showErrorMessage,showSuccessMessage} = useMessage();
const [messageopen,setMessageOpen]=useState("")
const [aenderung,setAenderung]=useState("");
const [turnusart,setTurnusArt]=useState("F");
const [turnuswert,setTurnusWert]=useState("");
useEffect(() => {
  if (startTurnus) {
    lade_turnus()
  } else {
    setTurnusKey("");
    setTage(neu_tage);
    setMonate(neu_monate);
    setArbeitestage(neu_arbeitstage);
  }
  // eslint-disable-next-line
}, [])
const errorcB = () => {
  setSpin(false);
  showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
}
const initCB = (response) => {
  setSpin(false);
  if (response.status === 200) {
    setTurnusKey(startTurnus)
    if (response.data.MONATE) {
      setMonate(response.data.MONATE)
    } 
    if (response.data.TAGE) {
      setTage(response.data.TAGE)
    } 
    if (response.data.ARBEITSTAGE) {
      setArbeitestage(response.data.ARBEITSTAGE)
    }
    if (response.data.fristart) {
      setTurnusArt(response.data.fristart)
    }
    if (response.data.fristwert) {
      setTurnusWert(response.data.fristwert)
    }
    if (response.data.feiertag) {
      setFeiertag(response.data.feiertag)
    }
  } else {
      if (response) {
       fehlertext.current=response.data?.message;
       setMessageOpen(true)
       setTurnusKey("");
       setTage(neu_tage);
       setMonate(neu_monate);
       setArbeitestage(neu_arbeitstage);
    //    showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
  }      
}
const lade_turnus = () => {
  setSpin(true);
  const payload={
    "mandant": client,
    "program": programm,
    "statement": "TURNUS_LADEN",
    "key":startTurnus,
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  apiRequest('POST', 'interview', payload, headers, initCB, errorcB);
}
const zeichne_neuanlage = () => {
  return(
    <Fragment>
      <Box p={1}>
        <Grid container spacing={2} >
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth color="primary"  onClick={()=> setOpen(false)} >{t(" Abbruch ")}</Button>
          </Grid>
          <Grid item xs={6}>
              <Button variant="contained" fullWidth color="primary"  onClick={()=> buttonClick("SPEICHERN","")} >{t(" Auswählen ")}</Button>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  )
}
const anfrageCB = (response) => {
   setSpin(false);
   if (response.status === 200) {
      setOpen(false);
      if (response.data.turnus_key) {
          setTurnusKey(response.data.turnus_key)
        }
      if (response.data.options) {
        setOptions(response.data.options)
      }
      if (response.data.auswertung) {
        setAuswertung(response.data.auswertung)
        setShowAuswertung(true)
      }
   } else {
       if (response) {
        fehlertext.current=response.data?.message;
        setMessageOpen(true)
     //    showErrorMessage(response.data.message);
       } else {
         showErrorMessage(t("Keine Internetverbindung"));
       }
   }      
 }
const speichern = () => {
  setSpin(true);
  const payload={
    "mandant": client,
    "program": programm,
    "statement": "TURNUS_SPEICHERN",
    "name":anlagename,
    "monate":monate,
    "tage":tage,
    "arbeitstage":arbeitstage,
    "feiertag":feiertag,
    "fristart":turnusart,
    "fristwert":turnuswert,
    "key":"NEU",
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  apiRequest('POST', 'interview', payload, headers, anfrageCB, errorcB);
}
const buttonClick = (spaltenkey,zeilenkey,zaehler,gridart) => {
   switch (spaltenkey) {
      case "TURNUSART":
        setTage(neu_tage);
        setMonate(neu_monate);
        setArbeitestage(neu_arbeitstage);
        setTurnusWert("");
        setAenderung("");
        setTurnusArt(zeilenkey)
       break; 
       case "TURNUSWERT":
        setAenderung(spaltenkey+zeilenkey);
        setTurnusWert(zeilenkey)
       break;        
      case "ABWÄHLEN":
        if (zeilenkey==="MONATE") {
          for ( let i=0; i<12; i++ ) {
            monate[i]["AUSWAHL"]="0"
          }
          setAenderung(zeilenkey+"ALLE0")
        }
        if (zeilenkey==="TAGE") {
          for ( let i=0; i<31; i++ ) {
            tage[i]["AUSWAHL"]="0"
          }
          setAenderung(zeilenkey+"ALLE0")
        }
        if (zeilenkey==="ARBEITSTAGE") {
          for ( let i=0; i<7; i++ ) {
            arbeitstage[i]["AUSWAHL"]="0"
          }
          setAenderung(zeilenkey+"ALLE0")
        }
       break;
      case "SPEICHERN":
        speichern()
       break;
      case "AUSWÄHLEN":
        if (zeilenkey==="MONATE") {
          for ( let i=0; i<12; i++ ) {
            monate[i]["AUSWAHL"]="1"
          }
          setAenderung(zeilenkey+"ALLE1")
        }
        if (zeilenkey==="TAGE") {
          for ( let i=0; i<31; i++ ) {
            tage[i]["AUSWAHL"]="1"
          }
          setAenderung(zeilenkey+"ALLE1")
        }
        if (zeilenkey==="ARBEITSTAGE") {
          for ( let i=0; i<7; i++ ) {
            arbeitstage[i]["AUSWAHL"]="1"
          }
          setAenderung(zeilenkey+"ALLE1")
        }
       break;
      case "AUSWAHL":
        if (gridart==="MONATE") {
          if (monate[zaehler][spaltenkey]==="1"){monate[zaehler][spaltenkey]="0";setAenderung(gridart+zaehler+"0");return}
          if (monate[zaehler][spaltenkey]==="0"){monate[zaehler][spaltenkey]="1";setAenderung(gridart+zaehler+"1");return}    
        }
        if (gridart==="TAGE") {
          if (tage[zaehler][spaltenkey]==="1"){tage[zaehler][spaltenkey]="0";setAenderung(gridart+zaehler+"0");return}
          if (tage[zaehler][spaltenkey]==="0"){tage[zaehler][spaltenkey]="1";setAenderung(gridart+zaehler+"1");return}    
        }
        if (gridart==="ARBEITSTAGE") {
          if (arbeitstage[zaehler][spaltenkey]==="1"){arbeitstage[zaehler][spaltenkey]="0";setAenderung(gridart+zaehler+"0");return}
          if (arbeitstage[zaehler][spaltenkey]==="0"){arbeitstage[zaehler][spaltenkey]="1";setAenderung(gridart+zaehler+"1");return}    
        }
       break;
       default:
       break;
   }
}
const handleResponse = (result) => {
  setMessageOpen(false);
  fehlertext.current=""
}
const zeichne_tabellen = () => {
  return (
    <Fragment>
   
   <Grid item xs={6} >
   <Box p={1}>
      <Typography color="primary">{t("Gültigkeit des Turnus in")}</Typography>
    </Box>  
    
    <Box p={1}>
      <TextField 
        variant="outlined"
        select
        value={turnusart}
        onChange={(event) =>  buttonClick("TURNUSART",event.target.value)}
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
      >
        <MenuItem value={"F"}>{t("feste Gültigkeit")}</MenuItem>
        <MenuItem value={"T"}>{t("Tage")}</MenuItem>
        <MenuItem value={"M"}>{t("Monate")}</MenuItem>
        <MenuItem value={"J"}>{t("Jahre")}</MenuItem>
      </TextField>
      </Box> 
   </Grid>
   
   <Grid item xs={6} >
    
    <Box p={1}>
    {turnusart!=="F" &&
      <Typography color="primary">{"Wert der Gültigkeit"}</Typography>
    }
    </Box>
     
     {turnusart!=="F" &&
    <Box p={1}>
    <Fragment>
     <TextField type="number" variant="outlined" value={turnuswert} onChange={(event) => buttonClick("TURNUSWERT",event.target.value)} ></TextField>
      </Fragment>  
    </Box>
        }
   </Grid>
   <Grid item xs={4} >
    <Paper style={{ height:900, width:"100%"}}>
    <Box p={1}>
      <Typography color="primary"> {"An welchem Monat?"} </Typography>
    </Box>
    <Box p={1}>
      <Fragment>
        <Button variant="outlined" onClick={()=> buttonClick("AUSWÄHLEN","MONATE",)} disabled={turnusart!=="F"} >{t(" Alle Auswählen ")}</Button>
        <Button variant="outlined" onClick={()=> buttonClick("ABWÄHLEN","MONATE",)} disabled={turnusart!=="F"}>{t(" Alle Abwählen")}</Button> 
      </Fragment>         
      <DynamicTable zeilen={ monate} spalten={turnusart==="F" ? spalten : spaltenlock} options={options} leertext={" "} hoehe={800} buttonCb={(spaltenkey,zeilenkey,zaehler) => buttonClick(spaltenkey,zeilenkey,zaehler,"MONATE")} minbreite={300}  size={"small"}/>   
    </Box>
   </Paper>
   </Grid>
   <Grid item xs={4} >
    <Paper style={{ height:900, width:"100%"}}>
    <Box p={1}>
      <Typography color="primary">{"An welchem Kalendertag?"}</Typography>
    </Box>
    <Box p={1}>
      <Fragment>
        <Button variant="outlined" onClick={()=> buttonClick("AUSWÄHLEN","TAGE",)} disabled={turnusart!=="F"}>{t(" Alle Auswählen ")}</Button>
        <Button variant="outlined" onClick={()=> buttonClick("ABWÄHLEN","TAGE",)} disabled={turnusart!=="F"}>{t(" Alle Abwählen")}</Button>
      </Fragment>
      <DynamicTable zeilen={tage} spalten={turnusart==="F" ? spalten : spaltenlock} options={options} leertext={" "} hoehe={800} buttonCb={(spaltenkey,zeilenkey,zaehler) => buttonClick(spaltenkey,zeilenkey,zaehler,"TAGE")} minbreite={300}  size={"small"} />        
    </Box>
   </Paper>
   </Grid>
   <Grid item xs={4} >
    <Paper style={{ height:900, width:"100%"}}>
    
    <Box p={1}>
      <Typography color="primary">{"Auch an Feiertagen?"} </Typography>
    </Box>  
    <Box p={1}>
      <TextField fullWidth variant="outlined" select 
        onChange={(e) => setFeiertag(e.target.value)}
        value={feiertag}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        disabled={turnusart!=="F"}
        >
          <MenuItem value={"0"}>{"Nein"}</MenuItem>
          <MenuItem value={"1"}>{"Ja"}</MenuItem>
        </TextField>
    </Box>  
    <Box p={1}>
      <Typography color="primary">{turnusart==="F" ? "An welchem Wochentag?" :""}</Typography>
    </Box>  
    <Box p={1}>
    { turnusart==="F" &&
      <Fragment>
      <Button variant="outlined" onClick={()=> buttonClick("AUSWÄHLEN","ARBEITSTAGE",)} disabled={turnusart!=="F"}>{t(" Alle Auswählen ")}</Button>
      <Button variant="outlined" onClick={()=> buttonClick("ABWÄHLEN","ARBEITSTAGE",)} disabled={turnusart!=="F"}>{t(" Alle Abwählen")}</Button>
      </Fragment>
    }
       <DynamicTable zeilen={arbeitstage} spalten={turnusart==="F" ? spalten : spaltenlock} options={options} leertext={" "} hoehe={800} buttonCb={(spaltenkey,zeilenkey,zaehler) => buttonClick(spaltenkey,zeilenkey,zaehler,"ARBEITSTAGE")} minbreite={300}  size={"small"} />   
    </Box>
   </Paper>
   </Grid>
   </Fragment>
  )
}
return (
  <Page >
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent="center">          
            <Grid item xs={12}>
            <Grid container justifyContent="center">  
              {  zeichne_tabellen()}
              </Grid> 
            </Grid>
            </Grid>
  
             {zeichne_neuanlage()}
           </Grid>
          </Grid>    
    { spin &&
      <FullPageSpinner/>
    }
    <MessageBox 
      open={messageopen}
      handleResponse={handleResponse}
      text={fehlertext.current}
      title={t("Hinweis")}
      onClose={() => handleResponse(false)}
    />
  </Page>
)
}
export default TurnusAuswahl;
